import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import {
  types as actions,
  setStatusSummaryAction
} from '../../reducers/actions';
import { StatusSummaryService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_STATUS_SUMMARY),
    switchMap(action =>
      StatusSummaryService.getAll(action.siteId, store).pipe(
        map(data => {
          return setStatusSummaryAction(data);
        })
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/status/getStatusSummary.js